import React, { Fragment } from "react";
import "./index.scss";
import phoneImg from "../../assets/phone.svg";
import logo from "./../../assets/kuaifu.svg";
import { RightOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { Form, Input, Button, Radio, message } from "antd";
import accountImg from "../../assets/account.svg";
// import request from './../../api/axios';
import md5 from 'js-md5';
import {
  Find_password,
  phoneCheck,
  passwordCheck,
} from "../../api/findPassword";
export default function FindPassword(props) {
  const [phone_loading, Setphone_loading] = useState(false),
    [change_loading, Setchange_loading] = useState(false),
    [conpassword_check, Setconpassword_check] = useState(false),
    [password_check, Setpassword_check] = useState(false),
    [passwordChecks, SetpasswordChecks] = useState(false),
    [conpasswordCheck, SetconpasswordCheck] = useState(false),
    [phone_color, Setphone_color] = useState(false),
    [phone_none, Setphone_none] = useState(false),
    [phoneMsg, SetphoneMsg] = useState(""),
    [yzmMsg, SetyzmMsg] = useState(""),
    [yzm_check, Setyzm_check] = useState(false),
    [phone_check, Setphone_check] = useState(false),
    [account, Setaccount] = useState(""), //选择账号
    [account_list, Setaccount_list] = useState([]), //账号列表
    [yzm, Setyzm] = useState(""), //验证码
    [password, Setpassword] = useState(""), //密码
    [conPassword, SetconPassword] = useState(""), //重复密码
    [passwordErrorFlag, SetpasswordErrorFlag] = useState(false),
    [phone_number, Setphone_number] = useState(""), //手机号
    [count_ture, Setcount_ture] = useState(false),
    [count, Setcount] = useState(undefined),
    [passwordInfoFlag, SetpasswordInfoFlag] = useState(false),
    [passwordmsg, Setpasswordmsg] = useState(""),
    [conpasswordErrorFlag, SetconpasswordErrorFlag] = useState(false),
    [conPasswordmsg, SetconPasswordmsg] = useState(""),
    [conPasswordInfoFlag, SetconPasswordInfoFlag] = useState(false),
    [timeDown, SettimeDown] = useState(10),
    [finish, Setfinish] = useState(false),
    [passwordFlag, SetpasswordFlag] = useState(true), //是否进入密码修改
    [radioValue, SetradioValue] = useState(0),
    [accountStr, SetaccountStr] = useState(""),
    [passwordChange, SetpasswordChange] = useState(true), //是否进入密码修改或账号选择
    [accountFindFlag, SetaccountFindFlag] = useState(false), //是否进入通过账号找回密码
    [phoneVerification, SetphoneVerification] = useState(true); //是否进入短信验证页面
  let timer;
  let password_modification_timer;

  //发送验证码
  function send_code() {
    if (accountFindFlag) {
      if (phone_number === "" || phone_number === undefined) {
        message.error("请填写帐号");
      } else {
        document.getElementById("codeBtn").disabled = "disabled";
        getmessage();
      }
    } else {
      if (phone_number === "" || phone_number === undefined) {
        message.error("请填写手机号");
      } else {
        document.getElementById("codeBtn").disabled = "disabled";
        getmessage();
      }
    }
  }
  //验证码短信请求
  async function getmessage() {
    let datas = {};
    if (accountFindFlag) {
      datas = { worker: phone_number, type: "account" };
    } else {
      datas = { worker: phone_number, type: "phone" };
    }

    let getVerification = await Find_password(datas);

    // if (getVerification.server_response.status_code === 201) {
    //   document.getElementById("codeBtn").style.backgroundColor = "#f5f5f5";
    //   count_down();
    // } else {
    //   document.getElementById("codeBtn").disabled = "";
    //   if (getVerification.server_response.status_code === 416) {
    //     Setphone_none(true);
    //     Setphone_color(true);
    //   } else {
    //     Setphone_none(false);
    //     message.error(getVerification.server_response.msg);
    //   }

    //   // Setphone_number("");
    // }
    if (getVerification.code === 201) {
      document.getElementById("codeBtn").style.backgroundColor = "#f5f5f5";
      if (accountFindFlag) {
        message.success(
          "验证码已发送至" +
            getVerification.data.phone.slice(0, 3) +
            "****" +
            getVerification.data.phone.slice(-4)
        );
      }
      count_down();
    } else {
      document.getElementById("codeBtn").disabled = "";
      if (getVerification.code === 416 || getVerification.code === 501) {
        Setphone_none(true);
        Setphone_color(true);
      } else {
        Setphone_none(false);
        message.error(getVerification.message);
      }
      // Setphone_number("");
    }
  }
  //60秒倒计时
  function count_down() {
    var count = 60;
    // const old_time=sessionStorage.getItem('time')
    password_modification_timer = setInterval(() => {
      //  let time=new Date().getTime()-old_time
      if (count <= 0) {
        clearInterval(password_modification_timer);
        // sessionStorage.removeItem('time')
        Setcount(undefined);
        document.getElementById("codeBtn").disabled = "";
        document.getElementById("codeBtn").style.backgroundColor = "#ffffff";
      } else {
        count = count - 1;
        Setcount(count);
        Setcount_ture(true);
      }
    }, 1000);
  }
  function countDown() {
    let count = 10;
    timer = setInterval(() => {
      if (document.getElementById("passwordFinish") === null) {
        clearInterval(timer);
      } else {
        if (count > 0) {
          count = count - 1;
          SettimeDown(count);
        } else {
          clearInterval(timer);
          props.history.push("/login");
        }
      }
    }, 1000);
  }
  //进入短信验证
  function verificationNext() {
    SetphoneVerification(false);
    SetaccountFindFlag(false);
  }
  function verifyByaccount() {
    SetphoneVerification(false);
    SetaccountFindFlag(true);
  }
  //返回上一步
  function findCancel() {
    SetphoneVerification(true);
    Setphone_number("");
    Setphone_check(false);
    Setyzm_check(false);
  }
  //进入账号选择或密码修改
  async function next() {
    var reg =
      /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    if (!accountFindFlag) {
      if (phone_number === "" || phone_number === undefined) {
        Setphone_check(true);
        SetphoneMsg("手机号未填写");
      }
      if (phone_number.length !== 11 || !reg.test(phone_number)) {
        Setphone_check(true);
        SetphoneMsg("手机号格式不正确");
      }
    } else {
      if (phone_number === "" || phone_number === undefined) {
        SetphoneMsg("帐号未填写");
        Setphone_check(true);
      } else {
        var reg = /^[a-zA-Z0-9@._]{8,59}$/;
        var reg2 = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
        if (!reg.test(phone_number) || reg2.test(phone_number)) {
          SetphoneMsg("帐号格式不正确");
          Setphone_check(true);
        } else {
          Setphone_check(false);
        }
      }
    }

    if (yzm === "") {
      Setyzm_check(true);
      SetyzmMsg("验证码未填写");
      // message.error("验证码不能为空");
    }
    // SetpasswordChange(false);
    // SetpasswordFlag(false);
    if (
      yzm_check === false &&
      phone_check === false &&
      phone_none === false &&
      yzm !== "" &&
      phone_number !== ""
    ) {
      Setphone_loading(true);
      const data = {
        phone: phone_number,
        code: yzm,
      };
      let phone_check = await phoneCheck(data);
      if (phone_check.code === 201) {
        console.log(phone_check);
        Setphone_loading(false);
        Setaccount_list(phone_check.data);
        SetpasswordChange(false);
        if (phone_check.data?.length <= 1) {
          SetpasswordFlag(false);
        }
      } else {
        Setphone_loading(false);
        message.error(phone_check.message);
      }
    }
  }

  function validatePassword(password) {
      let typesCount = 0;
      let hasSpaceOrChinese = /\s|\p{Script=Han}/u.test(password);

      // 检查每种字符类型，并统计类型数量
      if (/[a-z]/.test(password)) typesCount++;
      if (/[A-Z]/.test(password)) typesCount++;
      if (/\d/.test(password)) typesCount++;
      if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) typesCount++; // 示例特殊字符集

      // 确保密码长度在8到20位之间
      if (!(password.length >= 8 && password.length <= 20)) {
          console.log("密码长度无效，必须在8到20位之间");
          return false;
      }

      // 确保没有空格和中文字符
      if (hasSpaceOrChinese) {
          return false;
      }

      // 检查是否至少包含三种类型的字符
      if (typesCount < 3) {
          return false;
      }
      return true;
  }

  function radioChange(e) {
    Setaccount(account_list[e.target.value].account);
    SetradioValue(e.target.value);
  }
  function writePassword() {
    SetpasswordFlag(false);
  }
  async function end() {
    if (password === "" || password === undefined) {
      Setpasswordmsg("密码未填写！");
      SetpasswordChecks(true);
      SetpasswordErrorFlag(true);
    }
    if (conPassword === "" || conPassword === undefined) {
      SetconPasswordmsg("确认密码未填写！");
      SetconpasswordErrorFlag(true);
      SetconpasswordCheck(true);
    }
    if ((conpasswordCheck || passwordChecks) && conpassword_check) {
    } else {
      if (
        password === "" ||
        password === undefined ||
        conPassword === "" ||
        conPassword === undefined
      ) {
      } else {
        Setchange_loading(true);
        let datas = {
          account: account || account_list[0].account,
          password1: password,
          password2: conPassword,
          code: yzm,
        };
        datas.password1 = md5(datas.password1);
        datas.password2 = md5(datas.password2);
        datas.phone = phone_number;
        
        let password_check = await passwordCheck(datas);
        if (password_check.code === 201) {
          Setfinish(true);
          countDown();
          Setchange_loading(false);
        } else {
          message.error(password_check.message);
          Setchange_loading(false);
        }
      }
    }
  }
  function passwordFocus() {
    SetpasswordErrorFlag(false);
    SetpasswordInfoFlag(true);
    SetpasswordChecks(false);
    Setpassword_check(true);
    // if(password===conPassword){
    //   SetconpasswordErrorFlag(false)
    // }
  }
  function passwordBlur() {
    SetpasswordInfoFlag(false);
    let reg =
      /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)(?![a-zA-Z]+$)\S{8,20}$/;

    if (!validatePassword(password)) {
      SetpasswordChecks(true);
      if (!password) {
        Setpasswordmsg("密码未填写！");
        SetpasswordErrorFlag(true);
      } else {
        console.log(password, conPassword);
        Setpasswordmsg("密码格式错误");
        SetpasswordErrorFlag(true);
      }
      SetpasswordErrorFlag(true);
    } else {
      if (password === conPassword) {
        SetconpasswordErrorFlag(false);
        SetconpasswordCheck(false);
      } else {
        if (conpassword_check) {
          SetconPasswordmsg("两次密码输入不匹配，请重新输入！");
          SetconpasswordErrorFlag(true);
          SetconpasswordCheck(true);
        }
      }
    }
  }

  function conpasswordFocus() {
    SetconpasswordErrorFlag(false);
    SetconPasswordInfoFlag(true);
    SetconpasswordCheck(false);
    Setconpassword_check(true);
  }
  function conpasswordBlur() {
    SetconPasswordInfoFlag(false);
    let reg =
      /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)(?![a-zA-Z]+$)\S{8,20}$/;
    if (!conPassword.match(reg)) {
      SetconpasswordCheck(true);
      // SetconpasswordSuccess(false);
      if (!conPassword) {
        SetconPasswordmsg("确认密码未填写！");
      } else {
        SetconPasswordmsg("确认密码格式错误");
      }
      SetconpasswordErrorFlag(true);
    } else if (password !== conPassword) {
      // SetconpasswordSuccess(false);
      SetconpasswordCheck(true);
      SetconPasswordmsg("两次密码输入不匹配，请重新输入！");
      SetconpasswordErrorFlag(true);
    } else {
      // SetconpasswordSuccess(true);
      SetconpasswordCheck(false);
    }
  }

  function goLogin() {
    clearInterval(timer);
    props.history.push("/login");
    // window.location.href = "/login";
  }
  //验证码填写
  function change_yzm(e) {
    Setyzm(e.target.value);
  }
  function focus_yzm() {
    SetyzmMsg("");
    Setyzm_check(false);
  }
  function blur_yzm() {
    if (yzm === "" || yzm === undefined) {
      SetyzmMsg("验证码未填写");
      Setyzm_check(true);
    }
  }

  //手机号填写
  function change_phone(e) {
    Setphone_number(e.target.value);
    document.getElementById("codeBtn").disabled = "disabled";
  }
  function focus_phone() {
    SetphoneMsg("");
    Setphone_none(false);
    Setphone_check(false);
    Setphone_color(false);
  }
  function blur_phone() {
    if (accountFindFlag) {
      if (phone_number === "" || phone_number === undefined) {
        SetphoneMsg("帐号未填写");
        Setphone_check(true);
      } else {
        var reg = /^[a-zA-Z0-9@._]{8,59}$/;
        var reg2 = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
        if (!reg.test(phone_number) || reg2.test(phone_number)) {
          SetphoneMsg("帐号格式不正确");
          Setphone_check(true);
        } else {
          Setphone_check(false);
        }
      }
    } else {
      if (phone_number === "" || phone_number === undefined) {
        SetphoneMsg("手机号未填写");
        Setphone_check(true);
      } else {
        var reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!reg.test(phone_number)) {
          SetphoneMsg("手机号格式不正确");
          Setphone_check(true);
        } else {
          Setphone_check(false);
        }
      }
    }
  }

  useEffect(() => {
    if (accountFindFlag) {
      if (phone_number.length >= 8 && phone_number.length <= 60) {
        document.getElementById("codeBtn").disabled = "";
      } else {
        if (document.getElementById("codeBtn")) {
          document.getElementById("codeBtn").disabled = "disabled";
        }
      }
    } else {
      var reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (phone_number.length === 11) {
        if (!reg.test(phone_number)) {
          document.getElementById("codeBtn").disabled = "disabled";
        } else {
          document.getElementById("codeBtn").disabled = "";
        }
      } else {
        if (document.getElementById("codeBtn")) {
          document.getElementById("codeBtn").disabled = "disabled";
        }
      }
    }
  }, [phone_number]);
  return (
    <div className="password">
      {finish ? (
        <div className="passwordFinish" id="passwordFinish">
          <div className="passwordFinishTitle">您已成功修改密码</div>
          <div className="passwordFinishTip">您可以使用新的密码登录快服网</div>
          <Button className="passwordFinishBtn" onClick={goLogin}>
            前往快服网体验产品({timeDown})
          </Button>
        </div>
      ) : (
        <div className="findPassword">
          <div className="createAccountHead">
            <p className="title">找回您的密码</p>
            <p className="text">您可以通过手机或帐号找回您的快服通行证密码</p>
          </div>
          {phoneVerification ? (
            <div>
              <div className="findPasswordContent">
                <div className="authentication">
                  <p className="title">身份验证</p>
                  <p className="content">
                    为了保护您的账户安全，快服需要验证您的身份，验证通过后即可修改您的密码。
                  </p>
                  <div className="phoneVerify" onClick={verificationNext}>
                    <div className="iconArea">
                      <img src={phoneImg}></img>
                    </div>
                    <div className="verificationText">
                      <div className="verificationTextTop">手机号验证</div>
                      <div className="verificationTextBottom">
                        请输入您绑定的手机号码，以验证身份
                      </div>
                    </div>
                    <div className="verificationNextImg">
                      <RightOutlined />
                    </div>
                  </div>
                  <div className="phoneVerify" onClick={verifyByaccount}>
                    <div className="iconArea">
                      <img src={accountImg}></img>
                    </div>
                    <div className="verificationText">
                      <div className="verificationTextTop">帐号验证</div>
                      <div className="verificationTextBottom">
                        请输入您的账号信息，以验证身份
                      </div>
                    </div>
                    <div className="verificationNextImg">
                      <RightOutlined />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : passwordChange ? (
            accountFindFlag ? (
              <div className="verificationByPhone">
                <div className="phoneCheck">
                  <div className="phoneCheckTitle">帐号验证</div>
                  <div className="phoneCheckTip">
                    请填写完整的账号以验证身份
                  </div>
                  <Form className="phoneCheckForm">
                    <Form.Item
                      // name='phone'
                      className="phone"
                      rules={[
                        { required: true, message: "请输入完整的手机号" },
                      ]}
                    >
                      <Input
                        value={phone_number}
                        onChange={change_phone}
                        style={{ width: 258, height: 40 }}
                        // className="phoneInput"
                        className={`phoneInput ${
                          phone_check || phone_color ? "active" : ""
                        }`}
                        placeholder="帐号"
                        onFocus={focus_phone}
                        onBlur={blur_phone}
                      />
                      <Button
                        className="phoneBtn"
                        id="codeBtn"
                        onClick={send_code}
                      >
                        {count
                          ? count + "s"
                          : count_ture === true
                          ? "重新发送"
                          : "发送验证码"}
                      </Button>
                    </Form.Item>
                    <div className="accountInfo ">
                      {phone_check ? (
                        <span
                          style={{ color: "#FA8C16" }}
                          className="messageError"
                        >
                          {phoneMsg}
                        </span>
                      ) : phone_none ? (
                        <div style={{ color: "#FA8C16" }}>
                          该帐号不存在，请先
                          <span
                            onClick={() => {
                              props.history.push("/create_account");

                              // "https://shop.71baomu.com/Account/reg";
                            }}
                            style={{
                              marginLeft: 8,
                              color: "#0471E3",
                              cursor: "pointer",
                            }}
                          >
                            注册帐号
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <Form.Item
                      // name='phone_code'
                      className="phoneCode"
                      rules={[
                        { required: true, message: "请输入短信中的验证码" },
                      ]}
                    >
                      <Input
                        value={yzm}
                        onChange={change_yzm}
                        style={{ width: 368, height: 40 }}
                        // className="phoneCodeInput"
                        className={`phoneCodeInput ${
                          yzm_check ? "active" : ""
                        }`}
                        placeholder="验证码"
                        onBlur={blur_yzm}
                        onFocus={focus_yzm}
                      />
                    </Form.Item>
                    <div className="accountInfos ">
                      {yzm_check ? (
                        <span
                          style={{ color: "#FA8C16" }}
                          className="messageError"
                        >
                          {yzmMsg}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </Form>
                  {/* <Button
                    className="phoneCheckBtn"
                    onClick={next}
                    loading={phone_loading}
                  >
                    下一步
                  </Button> */}
                  <div className="buttonArea">
                    {/* <Button
                      className="phoneCheckBtnCancle"
                      onClick={findCancel}
                      loading={phone_loading}
                    >
                      上一步
                    </Button> */}
                    <Button
                      className="phoneCheckBtn"
                      onClick={next}
                      loading={phone_loading}
                    >
                      下一步
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="verificationByPhone">
                <div className="phoneCheck">
                  <div className="phoneCheckTitle">手机号验证</div>
                  <div className="phoneCheckTip">
                    请填写完整的手机号以验证身份
                  </div>
                  <Form className="phoneCheckForm">
                    <Form.Item
                      // name='phone'
                      className="phone"
                      rules={[
                        { required: true, message: "请输入完整的手机号" },
                      ]}
                    >
                      <Input
                        value={phone_number}
                        onChange={change_phone}
                        style={{ width: 258, height: 40 }}
                        // className="phoneInput"
                        className={`phoneInput ${
                          phone_check || phone_color ? "active" : ""
                        }`}
                        placeholder="手机"
                        onFocus={focus_phone}
                        onBlur={blur_phone}
                      />
                      <Button
                        className="phoneBtn"
                        id="codeBtn"
                        onClick={send_code}
                      >
                        {count
                          ? count + "s"
                          : count_ture === true
                          ? "重新发送"
                          : "发送验证码"}
                      </Button>
                    </Form.Item>
                    <div className="accountInfo ">
                      {phone_check ? (
                        <span
                          style={{ color: "#FA8C16" }}
                          className="messageError"
                        >
                          {phoneMsg}
                        </span>
                      ) : phone_none ? (
                        <div style={{ color: "#FA8C16" }}>
                          该手机号不存在，请先
                          <span
                            onClick={() => {
                              props.history.push("/create_account");
                              // window.open(
                              //   "https://www.53kf.com/reg/index?url=http://www.53kf.com&recode=&proxy=&yx_from=&sub_yx_from=&cps_id="
                              // );
                              // "https://shop.71baomu.com/Account/reg";
                            }}
                            style={{
                              marginLeft: 8,
                              color: "#0471E3",
                              cursor: "pointer",
                            }}
                          >
                            注册帐号
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <Form.Item
                      // name='phone_code'
                      className="phoneCode"
                      rules={[
                        { required: true, message: "请输入短信中的验证码" },
                      ]}
                    >
                      <Input
                        value={yzm}
                        onChange={change_yzm}
                        style={{ width: 368, height: 40 }}
                        // className="phoneCodeInput"
                        className={`phoneCodeInput ${
                          yzm_check ? "active" : ""
                        }`}
                        placeholder="验证码"
                        onBlur={blur_yzm}
                        onFocus={focus_yzm}
                      />
                    </Form.Item>
                    <div className="accountInfos ">
                      {yzm_check ? (
                        <span
                          style={{ color: "#FA8C16" }}
                          className="messageError"
                        >
                          {yzmMsg}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </Form>
                  <div className="buttonArea">
                    {/* <Button
                      className="phoneCheckBtnCancle"
                      onClick={findCancel}
                      loading={phone_loading}
                    >
                      上一步
                    </Button> */}
                    <Button
                      className="phoneCheckBtn"
                      onClick={next}
                      loading={phone_loading}
                    >
                      下一步
                    </Button>
                  </div>
                </div>
              </div>
            )
          ) : passwordFlag ? (
            <div className="accountChange">
              <div className="accountMain">
                <div className="accountTitle">选择账号</div>
                <div className="accountTip">
                  该手机号绑定了多个账户，请选择要修改密码的账户
                </div>
                <div className="accountList">
                  <Radio.Group onChange={radioChange} value={radioValue}>
                    {account_list.map((ele, index) => {
                      return (
                        <div className="accountListBox">
                          <div className="accountListLeft">
                            <img src={logo} className="accountListImg"></img>
                            <div
                              className={`accountListFent ${
                                radioValue === index ? "active" : ""
                              }`}
                            >
                              <div className="accountListFentTop">
                                {ele.name === null ? ele.account : ele.name}
                              </div>
                              <div className="accountListFentBottom">
                                {ele.account}
                              </div>
                            </div>
                          </div>
                          <Radio value={index}></Radio>
                        </div>
                      );
                    })}
                  </Radio.Group>
                </div>
                <Button className="accountBtn" onClick={writePassword}>
                  确定
                </Button>
              </div>
            </div>
          ) : (
            <div className="modifyPassword">
              <div className="modifyPasswordMain">
                <div className="modifyPasswordTitle">设置您的新密码</div>
                <div className="modifyPasswordTip">
                  账号：
                  {account || account_list[0].account}
                </div>
                <p>
                  <Input.Password
                    placeholder="密码"
                    // className="accountInout"
                    className={`accountInout ${passwordChecks ? "active" : ""}`}
                    value={password}
                    onChange={(e) => {
                      let reg = new RegExp(/\s+/g);
                      let regs = new RegExp("[\\u4E00-\\u9FFF]+", "g");
                      // let reg = /^[\u4e00-\u9fa5]+$/;
                      if (
                        e.target.value === "" ||
                        e.target.value === undefined
                      ) {
                        Setpassword(e.target.value);
                      } else {
                        if (!regs.test(e.target.value)) {
                          if (!reg.test(e.target.value)) {
                            Setpassword(e.target.value);
                          }
                        }
                      }
                      // Setpassword(e.target.value);
                    }}
                    onFocus={passwordFocus}
                    onBlur={passwordBlur}
                  />
                </p>
                <div className="accountInfo ">
                  {passwordInfoFlag ? (
                    <span className="password-remark">密码长度为8-20位，且同时包含大写字母、小写字母、数字、特殊字符中的三种，且不能含有空格和中文！</span>
                  ) : (
                    ""
                  )}
                  {passwordErrorFlag ? (
                    <span style={{ color: "#FA8C16" }} className="messageError">
                      {passwordmsg}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <p className="modifyPasswordP">
                  <Input.Password
                    placeholder="密码确认"
                    // className="accountInout"
                    className={`accountInout ${
                      conpasswordCheck ? "active" : ""
                    }`}
                    value={conPassword}
                    onChange={(e) => {
                      // SetconPassword(e.target.value);
                      let reg = new RegExp(/\s+/g);
                      let regs = new RegExp("[\\u4E00-\\u9FFF]+", "g");
                      if (
                        e.target.value === "" ||
                        e.target.value === undefined
                      ) {
                        SetconPassword(e.target.value);
                      } else {
                        if (!regs.test(e.target.value)) {
                          if (!reg.test(e.target.value)) {
                            SetconPassword(e.target.value);
                          }
                        }
                      }
                    }}
                    onFocus={conpasswordFocus}
                    onBlur={conpasswordBlur}
                  />
                </p>
                <div className="accountInfo ">
                  {conPasswordInfoFlag ? (
                    <span>密码长度为8-20位，且同时包含大写字母、小写字母、数字、特殊字符中的三种，且不能含有空格和中文！</span>
                  ) : (
                    ""
                  )}
                  {conpasswordErrorFlag ? (
                    <span style={{ color: "#FA8C16" }} className="messageError">
                      {conPasswordmsg}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <Button
                  className="newPasswordBtn"
                  onClick={end}
                  loading={change_loading}
                >
                  {change_loading ? "确定中" : "确定"}
                </Button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
